import Block from './blocks/block';
import TextBlock from './blocks/text-block';
import SpacerBlock from './blocks/spacer-block';
import TitleBlock from './blocks/title-block';
import ImageBlock from './blocks/image-block';
import PdfBlock from './blocks/pdf-block';
import VideoBlock from './blocks/video-block';
import AudioBlock from './blocks/audio-block';
import GradingPolicyBlock from './blocks/grading-policy-block';
import SessionListBlock from './blocks/session-list-block';
import CourseworkListBlock from './blocks/coursework-list-block';
import InstructorsListBlock from './blocks/instructors-list-block';
import CoursePromoBlock from './blocks/course-promo-block';
import CourseLogoBlock from './blocks/course-logo-block';

export default {
  data() {
    return {
      course: null,
      blocks: []
    };
  },

  components: {
    Block,
    TextBlock,
    TitleBlock,
    SpacerBlock,
    ImageBlock,
    PdfBlock,
    VideoBlock,
    AudioBlock,
    GradingPolicyBlock,
    SessionListBlock,
    CourseworkListBlock,
    InstructorsListBlock,
    CoursePromoBlock,
    CourseLogoBlock
  },

  methods: {
    bindData(data, enrolled) {
      this.course = data;

      this.blocks = this.course.syllabus_blocks.filter(b =>
        enrolled || b.data.showOnPublicSyllabus
      ).map(b => {
        b.rootData = b.data;
        delete b.data;
        return b;
      }).sort( (a, b) => a.order - b.order );
    }
  }
};
